import { PopupConfigData } from './popup-config-data';

export class PopupConfig {
    public id: string;
    public hideclass: string|boolean;
    public alignoff: boolean;
    public autoposoff: boolean;


    constructor(id?: string, inParams?: PopupConfigData) {
        let params = inParams;

        if (!inParams) {
            params = {};
        }

        this.id = id ? id : null;
        this.hideclass = params.hideclass ? params.hideclass : false;
        this.alignoff = params.alignoff ? params.alignoff : false;
        this.autoposoff = params.autoposoff ? params.autoposoff : false;
    }
}
